import { getTokenCookie } from '@shared/lib';

import { ApplicationState } from './types';

export const APPLICATION_SLICE_NAME = 'application';

const initialAuthToken = getTokenCookie();

export const APPLICATION_INITIAL_STATE: ApplicationState = {
  appInitialized: false,
  appBanned: false,
  captchaToken: null,
  authToken: initialAuthToken,
  appStatus: initialAuthToken ? 'initializing' : 'idle',
};
